module.exports = __webpack_public_path__ + "img/26.6d9f23ff.jpg";